import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)

const PLACEHOLDER_DATES = new Set(['1899-11-30'])

const isPlaceholderDate = (date) => (
  date?.isValid?.() && PLACEHOLDER_DATES.has(date.format('YYYY-MM-DD'))
)

// Try to parse a variety of common backend date formats safely
export const parseDateValue = (input) => {
  if (!input) return null

  if (typeof input === 'string' && PLACEHOLDER_DATES.has(input.trim().slice(0, 10))) {
    return null
  }

  // Already a valid ISO or Date/number
  const direct = dayjs(input)
  if (direct.isValid()) return isPlaceholderDate(direct) ? null : direct

  // Strict parse common MySQL-like and ISO variants
  const candidates = [
    'YYYY-MM-DD',
    'YYYY-MM-DD HH:mm:ss',
    'YYYY-MM-DDTHH:mm:ss',
    'YYYY-MM-DDTHH:mm:ss[Z]',
    'YYYY-MM-DDTHH:mm:ss.SSS[Z]'
  ]

  for (const fmt of candidates) {
    const d = dayjs(input, fmt, true)
    if (d.isValid()) return isPlaceholderDate(d) ? null : d
  }

  // Last attempt: replace space with T
  if (typeof input === 'string' && input.includes(' ')) {
    const replaced = input.replace(' ', 'T')
    const again = dayjs(replaced)
    if (again.isValid()) return isPlaceholderDate(again) ? null : again
  }

  return null
}

export const formatDate = (dateStr) => {
  const d = parseDateValue(dateStr)
  if (!d) return ''
  return d.format('DD/MM/YYYY')
}

export const formatDateWithTime = (dateStr) => {
  const d = parseDateValue(dateStr)
  if (!d) return ''
  return d.format('DD/MM/YYYY HH:mm')
}

export const formatDateForInput = (dateStr) => {
  const d = parseDateValue(dateStr)
  return d ? d.format('YYYY-MM-DD') : ''
}

export const serializeDate = (value) => {
  const d = parseDateValue(value)
  return d ? d.format('YYYY-MM-DD') : null
}
